// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WiYT0","Brand":"Footer_Brand__giWUB"};